import Axios from "axios";
import { verifyToken } from "../auth/auth";
import { tokenKey } from "../constants/constants";
export const axiosInstance = Axios.create();

axiosInstance.interceptors.request.use(
  (config) => {
    //set headers
    config.headers["authorization"] =
      "Bearer " + localStorage.getItem(tokenKey);
    if (
      !config.url.search("login") &&
      !verifyToken(localStorage.getItem(tokenKey))
    ) {
      localStorage.removeItem(tokenKey);
      return window.location.reload();
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);
